import React, { memo, useCallback, useId, useState } from 'react';
import { ChevronDown16Regular } from '@fluentui/react-icons';
import BlockMarkdown from './BlockMarkdown';
import { extractBlockMarkdown, extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function ExpandableSectionBlock({ block, renderContext, renderNested }) {
    const [expanded, setExpanded] = useState(Boolean(block.defaultExpanded));
    const panelId = useId();
    const title = block.title || block.label || 'Details';
    const content = extractBlockMarkdown(block);
    const nestedBlocks = extractBlockItems(block).length ? extractBlockItems(block) : block.blocks;

    const toggle = useCallback(() => {
        setExpanded(prev => !prev);
    }, []);

    const hasNestedBlocks = Array.isArray(nestedBlocks) && nestedBlocks.length > 0;
    const hasContent = Boolean(content) || hasNestedBlocks;
    if (!hasContent) return null;

    return (
        <section className={styles.expandableBlock}>
            <button
                type="button"
                className={styles.expandableTrigger}
                aria-expanded={expanded}
                aria-controls={panelId}
                onClick={toggle}>
                <span className={styles.expandableTitle}>{title}</span>
                <ChevronDown16Regular
                    className={`${styles.expandableIcon} ${expanded ? styles.expandableIconOpen : ''}`.trim()}
                    aria-hidden
                />
            </button>
            {expanded ? (
                <div id={panelId} className={styles.expandablePanel}>
                    {content ? <BlockMarkdown content={content} {...renderContext} /> : null}
                    {hasNestedBlocks && renderNested ? renderNested(nestedBlocks) : null}
                </div>
            ) : null}
        </section>
    );
}

export default memo(ExpandableSectionBlock);
